import HttpRequest from "@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest";
import SnackbarUtils from "@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils";
import User from "bower_components/teknisavuecomponents/assets/interfaces/User";
import store from '../../../store/store';

class IntervaloController {
  public static async getVinculoTodos(
    dtMesCompetencia?: string,
  ) {
    const nrOrg = store.getters.user.nrorg;

    const route = 'getVinculoTodos';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      DTMESCOMPETENC: dtMesCompetencia,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const vinculos: any[] = response.data.dataset.data;

      return vinculos;

    } catch (err) {
      const errorMessage = 'Não foi possível carregar os vínculos!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getVinculoTodosResp(
    dtMesCompetencia?: string,
  ) {
    const user: User = store.getters.user;

    const nrOrg = user.nrorg;
    const cdOperador = user.cdoperador;

    const route = 'getVinculoTodosResp';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      CDOPERADOR: cdOperador,
      DTMESCOMPETENC: dtMesCompetencia,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const vinculos: any[] = response.data.dataset.data;

      return vinculos;

    } catch (err) {
      const errorMessage = 'Não foi possível carregar os vínculos!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getVinculoByCPF(
    nrCpf?: string,
  ) {
    const nrOrg = store.getters.user.nrorg;

    const route = 'getVinculoByCPF';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRCPF: nrCpf,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const vinculos: any[] = response.data.dataset.data;

      return vinculos;

    } catch (err) {
      const errorMessage = 'Não foi possível carregar o vínculo pelo CPF!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async enviarVinculosParaServidor(
    dtMesCompetencia?: string,
  ) {
    const user: User = store.getters.user;

    const nrOrg = user.nrorg;
    const cdOperador = user.cdoperador;

    const route = 'getVinculoTodosResp';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      CDOPERADOR: cdOperador,
      DTMESCOMPETENC: dtMesCompetencia,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const vinculos: any[] = response.data.dataset.data;

      return vinculos;

    } catch (err) {
      const errorMessage = 'Não foi possível carregar os vínculos!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }


  public static async getEnderecoVinculo(
    nrvinculom?: string,
  ) {
    const nrOrg = store.getters.user.nrorg;

    const route = 'getEnderecoParc';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRVINCULOM: nrvinculom,
    };

    try {
      const response = await HttpRequest.get(route, params);
      const vinculos: any[] = response.data.dataset.data;

      return vinculos;

    } catch (err) {
      const errorMessage = 'Não foi possível carregar o endereço do vínculo!';
      SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }
}

export default IntervaloController;